
import UserSearchCard from './components/UserSearchCard/UserSearchCard.vue'
import UserSummaryCard from '@/views/private/realestate/users/components/UserSummaryCard/UserSummaryCard.vue'
import RealtorTable from '@/views/private/realestate/users/components/RealtorTable/RealtorTable.vue'
import UserAddModal from '@/views/private/realestate/users/components/UserAddModal/UserAddModal.vue'
import UserEditForm from '@/views/private/realestate/users/components/UserEditForm/UserEditForm.vue'
import CustomerTabs from '@/views/private/realestate/users/components/CustomerTabs/CustomerTabs.vue'
import usermanagement from '@/shared/http/repositories/realestate/usermanagement'
import { toast, loading } from '@/shared/utils/UIHelper'
import PermissionMixin from '@/store/module/permission/mixin'
import Roles from '@/shared/utils/roles.js'

export default {
  name: 'RealtorBoard',
  mixins: [ PermissionMixin ],
  components: {
    UserSearchCard,
    UserSummaryCard,
    RealtorTable,
    UserAddModal,
    UserEditForm,
    CustomerTabs
  },
  data () {
    return {
      headTable: ['NOME', 'CPF', 'RG', 'CRECI', 'UF CRESCI', 'STATUS', 'DT. DE CADASTRO', 'IMOBILIARIA', ''],
      editUser: {},
      isUserSelected: false,
      administrador: false,
      keyTableUsers: 0,
      corretor: true,
      roles: Roles
    }
  },
  methods: {

    validateState (ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref)
      }
      return null
    },
    onSubmit (e) {
      e.preventDefault()
      this.$validator.validateAll().then(result => {
        if (!result) {
          return
        };
      })
    },
    updateView (newV) {
      this.isUserSelected = newV
    },
    updateTableUsers () {
      this.keyTableUsers++
    },
    selectUser (userSelected) {
      this.editUser = userSelected
      this.isUserSelected = true
    },
    deleteUser (user) {
      usermanagement.DeleteCorretor(user.id)
        .then(res => {
          if (res.status === 200) {
            this.updateTableUsers()
            toast.success(`Usuário deletado com sucesso`)
            loading.pop()
          }
        })
        .catch(() => {
          toast.error(`Erro ao deletar usuário`)
          loading.pop()
        })
    },
    inactivateUser (user) {
      usermanagement.TrocarStatusCorretor(user.id)
        .then(res => {
          if (res.status === 200) {
            toast.success(`Status do corretor alteradado com sucesso`)
            loading.pop()
            this.updateTableUsers()
          }
        })
        .catch(() => {
          toast.error(`Erro ao trocar status do corretor`)
          loading.pop()
        })
    },
    GetFilter (filter, isFilter) {
      this.$refs.tableUsersComponent.searchWithFilter(filter, isFilter)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/users/realtors.js